import React from 'react';
import './Controls.css';

const Controls = ({ isMuted, isSpeakerOn, isMicOn, onToggleMute, onToggleSpeaker, onToggleMic, onEndCall }) => {
  return (
    <div className="call-controls">
      <button
        className={`control-btn ${isMuted ? 'active' : ''}`}
        onClick={onToggleMute}
        title={isMuted ? 'Unmute' : 'Mute'}
      >
        <i className={`bi bi-volume-up${isMuted ? '-mute' : ''}-fill`}></i>
        <span>{isMuted ? 'Muted' : 'Mute'}</span>
      </button>
      <button
        className={`control-btn ${!isSpeakerOn ? 'active' : ''}`}
        onClick={onToggleSpeaker}
        title={isSpeakerOn ? 'Mute Speaker' : 'Unmute Speaker'}
      >
        <i className={`bi bi-mic${!isSpeakerOn ? '-mute' : ''}-fill`}></i>
        <span>{isSpeakerOn ? 'Speaker' : 'Muted'}</span>
      </button>
      <button
        className={`control-btn ${!isMicOn ? 'active' : ''}`}
        onClick={onToggleMic}
        title={isMicOn ? 'Disable Mic' : 'Enable Mic'}
      >
        <i className={`bi bi-mic${!isMicOn ? '-mute' : ''}-fill`}></i>
        <span>{isMicOn ? 'Mic On' : 'Mic Off'}</span>
      </button>
      <button className="control-btn end-call" onClick={onEndCall} title="End Call">
        <i className="bi bi-telephone-fill"></i>
        <span>End</span>
      </button>
    </div>
  );
};

export default Controls;
